<template>
  <div class="p-0 m-0 text-left">
    <template v-if="profileData">
      <span v-if="fromProporsal" class="font-weight-bold">1. {{ $t("lang.onBoarding.billing_information") }}</span>
      <vue-form-generator
        ref="vfg"
        :schema="schema"
        :model="this.model"
        :options="formOptions"
      ></vue-form-generator>
      <span
        class="loadingres d-flex p-2 spinner-border loading-spinner mx-auto"
        v-if="loading"
      ></span>
      <div v-if="showerror && !loading">
        <h4 class="text-danger">
          {{ $t("lang.label.error") }}:
          {{ $t("lang.label.yourcreditcardhasnotbeenauthorized") }}
        </h4>
      </div>
      <div class="row mt-1 mb-0 pt-3" v-if="profileData">
        <span v-if="fromProporsal" class="font-weight-bold mb-3 ml-3">2. {{ $t("lang.onBoarding.choose_payment_method") }}</span>
        <!-- Botones de tipo de forma de pago. credit/debito o Debito directo -->
        <div class="col-12 d-flex justify-content-center">
          <!-- Boton Tarjeta credito/debito -->
          <button
            v-if="bank_transfer_enabled != 1"
            class="btn btn-primary themed-button mr-2 p-2 rounded-lg"
            :disabled="btnMethods.creditCard.disabled"
            @click="showMethods('creditCard')"
            type="submit"
          >
            <span class="btn-width" v-if="btnMethods.creditCard.loading">
              <Loadingcircle :paramloading="paramloading" />
            </span>
            <span v-else>
              <span class="icon-credit-card mx-1"></span>
              {{ $t("lang.label.credit_debit") }}
            </span>
          </button>

          <!-- Boton Debito Directo Sepa1 -->
          <button
            v-if="bank_transfer_enabled != 1"
            class="btn btn-primary themed-button ml-2"
            :disabled="btnMethods.sepa.disabled"
            @click="optionSepaMethod()"
            type="submit"
          >
            <span class="btn-width" v-if="btnMethods.sepa.loading">
              <Loadingcircle :paramloading="paramloading" />
            </span>
            <span v-else>
              <span class="icon-bank mx-1"></span>
              {{ $t("lang.label.direct_debit") }}
            </span>
          </button>

          <!-- Boton Bank Transfer -->
          <button class="btn btn-primary themed-button ml-2" 
          v-if="bank_transfer_enabled == 1"
            @click="optionBankTransfer()" type="submit">
            <span class="btn-width" v-if="btnMethods.bankTransfer.loading">
              <Loadingcircle :paramloading="paramloading" />
            </span>
            <span v-else>
              <span class="icon-banknote mx-1"></span>
              {{ $t("lang.label.bank_transfer") }}
            </span>
          </button>
        </div>
        <div v-if="bank_transfer_enabled == 1"
          class="col-12 d-flex justify-content-center mt-2">
            <p class="text-warning">* {{ bank_transfer_contractual_days  }} {{$t("lang.column.bank_transfer_contractual_days") }}</p>
          </div>
      </div>
    </template>
    <Modal
      :name="'sepaPaymentMethod'"
      height="75%"
      width="40%"
      :max-width="500"
    >
      <BankAccountForm
        :anonymousType="userId ? true : false"
        :isSigning="true"
        :profileData="selectedMethod"
        :userId ="userId"
      />
    </Modal>
  </div>
</template>

<script>
import { frenchVatError } from "@/_helpers/frenchVat";

import Vue from "vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import BankAccountForm from "@/components/Billing/BankAccountForm.vue";
import VueFormGenerator from "vue-form-generator";
import "vue-form-generator/dist/vfg.css";
import Header from "@/components/Header.vue";
import Loadingcircle from "@/components/Common/Loadingcircle.vue";
import {
  billingsService,
  usersService,
  campaignsService,
  plansService,
  proporsalService,
} from "@/_services";
import { mapState, mapActions } from "vuex";
import $ from "jquery";

export default {
  props: {
    selectedMethod: {
      type: Object,
      default() {
        return {};
      },
    },
    subscriptionData: {
      type: Object,
      default() {
        return {};
      },
    },
    title: {
      type: String,
      default: "Save",
    },
    showSaveButton: {
      type: Boolean,
      default: true,
    },
    showPrincipal: {
      type: Boolean,
      default: true,
    },
    confirmPayment: {
      type: Boolean,
      default: true,
    },
    profileData: {
      type: Boolean,
      default: false,
    },
    userId: {
      type: String,
      default: null,
    },
    email: {
      type: String,
      default: null,
    },
    phone: {
      type: String,
      default: null,
    },
    fromProporsal: {
      type: Boolean,
      default: false,
    },
    bank_transfer_enabled: {
      type: Number,
      default: 0,
    },
    bank_transfer_contractual_days: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      paramloading: {
        width: "28px",
        height: "28px",
        color: "#fff",
      },
      btnMethods: {
        sepa: {
          loading: false,
          disabled: false,
        },
        creditCard: {
          loading: false,
          disabled: false,
        },
        bankTransfer: {
          loading: false,
          disabled: true,
        },
      },
      listCountryIdToVatNumber: [
        "14",
        "21",
        "33",
        "54",
        "56",
        "57",
        "58",
        "72",
        "73",
        "80",
        "83",
        "97",
        "103",
        "105",
        "117",
        "123",
        "124",
        "132",
        "150",
        "171",
        "172",
        "176",
        "193",
        "194",
        "199",
        "205",
      ],
      showerror: false,
      profileCountries: [],
      schema: {
        fields: [
          {
            type: "input",
            inputType: "hidden",
            model: "id",
            readonly: true,
            featured: false,
            disabled: true,
          },
          /*{
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.nameoncard"),
            model: "name_on_card",
            readonly: false,
            required: true,
            disabled: (model) => {
              if (this.checkExpiration(model)) {
                return true;
              }
              return false;
            },
            min: 5,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-12",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.cardnumber"),
            model: "card_number",
            readonly: false,
            required: true,
            disabled: (model) => {
              if (this.checkExpiration(model)) {
                return true;
              }
              return false;
            },
            min: 15,
            max: 19,
            id: "cardnumber",
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-12",
          },
          {
            type: "select",
            label: this.$t("lang.label.expirationmonth"),
            model: "expiration_month",
            readonly: false,
            required: true,
            disabled: (model) => {
              if (this.checkExpiration(model)) {
                return true;
              }
              return false;
            },
            styleClasses: "col-md-4",
            selectOptions: {},
            values: [],
            validator: VueFormGenerator.validators.required.locale({
              fieldIsRequired: this.$t("lang.label.required"),
            }),
          },
          {
            type: "select",
            label: this.$t("lang.label.expirationyear"),
            model: "expiration_year",
            readonly: false,
            required: true,
            disabled: (model) => {
              if (this.checkExpiration(model)) {
                return true;
              }
              return false;
            },
            styleClasses: "col-md-4",
            selectOptions: {},
            values: [],
            validator: VueFormGenerator.validators.required.locale({
              fieldIsRequired: this.$t("lang.label.required"),
            }),
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.cvc"),
            model: "cvc",
            readonly: false,
            required: true,
            disabled: (model) => {
              if (this.loading) {
                return true;
              }
              return false;
            },
            styleClasses: "col-md-4",
            min: 3,
            max: 4,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
          },*/
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.address"),
            model: "address",
            readonly: false,
            required: true,
            disabled: false,
            min: 5,
            visible: (model) => {
              return this.profileData;
            },
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
            }),
            styleClasses: "col-12",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.postalcode"),
            model: "code_postal",
            readonly: false,
            required: true,
            disabled: false,
            min: 3,
            visible: (model) => {
              return this.profileData;
            },
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
            }),
            styleClasses: "col-6",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.column.city"),
            model: "city",
            readonly: false,
            required: true,
            disabled: false,
            min: 5,
            visible: (model) => {
              return this.profileData;
            },
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
            }),
            styleClasses: "col-6",
          },
          {
            type: "select",
            inputType: "text",
            label: this.$t("lang.label.country"),
            model: "country_id",
            readonly: false,
            required: true,
            disabled: false,
            selectOptions: {},
            visible: (model) => {
              return this.profileData;
            },
            values: () => {
              return this.profileCountries;
            },
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
            }),
            styleClasses: "col-6",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.vat_number"),
            model: "vat_number",
            readonly: false,
            required: (model) =>
              model && this.listCountryIdToVatNumber.includes(model.country_id)
                ? true
                : false,
            min: 5,
            visible: (model) =>
              model && this.listCountryIdToVatNumber.includes(model.country_id),
            validator: (value, field, model) => {
              if (String(model && model.country_id) === "73") {
                const error = frenchVatError(value);
                return error ? [error] : [];
              }
              return value ? [] : [this.$t("lang.label.required")];
            },
            styleClasses: "col-6",
          },
          {
            type: "switch",
            label: this.$t("lang.label.markasprincipal"),
            model: "default",
            multi: true,
            default: 1,
            textOn: this.$t("lang.label.principal"),
            textOff: this.$t("lang.label.no"),
            valueOn: "1",
            valueOff: "0",
            visible: (model) => {
              return this.showPrincipal;
            },
            styleClasses: "col-md-4",
          },
        ],
      },
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true,
      },
    };
  },

  watch: {
    "model.name_on_card"() {
      this.model.name_on_card = this.$sanitize(this.model.name_on_card);
    },
    "model.card_number"() {
      let cardnumber;
      cardnumber = this.$sanitize(this.model.card_number);
      this.model.card_number = cardnumber.replace(" ", "");
    },
    "model.cvc"() {
      this.model.cvc = this.$sanitize(this.model.cvc);
    },
  },

  components: {
    Loadingcircle,
    Header,
    LoadingSpinner,
    BankAccountForm,
    "vue-form-generator": VueFormGenerator.component,
  },
  created() {
    window.dataLayer.push({
      event: "Funnel_Paiement",
      stepName: "Chargement Pop-In Paiement",
      stepNumber: "2.3",
    });

    //this.getMonths();
    //this.getYears();
    this.checkPlan();
    if (this.profileCountries.length == 0) {
      this.$store.dispatch("optionsList/getProfileCountries").then(() => {
        if(this.Countries.length > 0){
          this.profileCountries = this.Countries;
        }
      })
    }
    this.initialDataToForm();
  },
  computed: {
    model() {
      return this.selectedMethod;
    },
    ...mapState({
      headerTab: (state) => state.header.tab,
      plans: (state) => state.plans.all,
      activePlans: (state) => state.plans.allActives,
      loading: (state) => state.billings.loading,
      user: (state) => state.authentication.user,
      Countries: (state) => state.optionsList.all["profile_countries"].data,
    }),
  },
  methods: {
    ...mapActions("billings", {
      startLoading: "startLoading",
      finishLoading: "finishLoading",
    }),
    ...mapActions("plans", {
      getAllPlans: "getAll",
    }),

    //If exists data ( address, code_posta, city ) in table client.
    initialDataToForm() {
      if (this.user) {
        this.model.address = this.user.client_address;
        this.model.code_postal = this.user.client_postal_code;
        this.model.city = this.user.client_city;
      }
    },
    optionSepaMethod() {
      this.$refs.vfg.validate();
      if (this.$refs.vfg.errors.length > 0) {
        $event.preventDefault();
        this.$swal({
          type: "error",
          title: this.$t("lang.label.error"),
          text: this.$t("lang.label.checkdeerrormessagesintheformandtryagain"),
          showConfirmButton: true,
        });
      } else {
        this.openModal("sepaPaymentMethod");
      }
    },
    optionBankTransfer() {
      this.$refs.vfg.validate();
      if (this.$refs.vfg.errors.length > 0) {
        this.$swal({
          type: "error",
          title: this.$t("lang.label.error"),
          text: this.$t("lang.label.checkdeerrormessagesintheformandtryagain"),
          showConfirmButton: true,
        });
        return false;
      }
      
      this.btnMethods.bankTransfer.loading = true;
      this.btnMethods.bankTransfer.disabled = true;

      let data = Object.assign({});
      data.isSigning = true;
      data.url = this.$route.path;
      data.role_id = 4;

      data.profileData = {};
      (data.profileData.address = this.selectedMethod.address),
      (data.profileData.country_id = this.selectedMethod.country_id),
      (data.profileData.code_postal = this.selectedMethod.code_postal),
      (data.profileData.city = this.selectedMethod.city),
      (data.profileData.vat_number = this.selectedMethod.vat_number
        ? this.selectedMethod.vat_number
          : null);
        
      if (this.userId) {
        data.user_id = this.userId;
        proporsalService.saveBankTransferPaymentMethod(data).then((response) => {
          window.dataLayer = window.dataLayer || [];
          dataLayer.push({
            event: "Paiement_Enregistré_Parcours_Commercial",
          });
          // reload page
          window.location.reload();
        });
      }else{
        console.log("it only works from the proposal")
      }
    },
    openModal(modalId) {
      this.$modal.show(modalId);
    },
    closeModal(modalId) {
      this.$modal.hide(modalId);
    },
    getModel() {
      this.$refs.vfg.validate();
      if (this.$refs.vfg.errors.length > 0) {
        return false;
      }
      return this.$refs.vfg.model;
    },
    checkPlan() {
      plansService.getAll().then((plans) => {
        if (this.subscriptionData.plan_id) {
          const plan = plans.find((plan) => {
            return plan.plan_id == this.subscriptionData.plan_id;
          });
          if (plan) {
            campaignsService.getActiveCampaigns().then((result) => {
              if (result) {
                if (
                  (plan.plan_id == 1 && result.total > 1) ||
                  (plan.plan_id == 2 && result.total > 3)
                ) {
                  this.$swal({
                    type: "error",
                    title: this.$t("lang.label.error"),
                    text: this.$t(
                      "lang.label.thenumberofactivecampaignsishigher"
                    ),
                    showConfirmButton: true,
                  });
                  this.$router.push("/upgrade");
                }
              }
            });
          } else {
            this.$swal({
              type: "error",
              title: this.$t("lang.label.error"),
              text: this.$t("lang.label.theplandoesntexists"),
              showConfirmButton: true,
            });
            this.$router.push("/upgrade");
          }
        }
      });
    },
    getMonths() {
      let field = this.schema.fields.find(
        (field) => field.model === "expiration_month"
      );
      let months = [];
      let i;
      for (i = 1; i <= 12; i++) {
        months[i] = i;
      }
      field.values = months;
    },
    getYears() {
      let field = this.schema.fields.find(
        (field) => field.model === "expiration_year"
      );
      let year = new Date().getFullYear();
      let years = [];
      let i;
      for (i = 0; i < 10; i++) {
        years[i + year] = i + year;
      }
      field.values = years;
    },
    checkExpiration(model) {
      if (this.loading) {
        return true;
      }

      if (this.selectedMethod.id) {
        if (model.expiration_year != "" && model.expiration_month != "") {
          var today = new Date();
          var lastDayOfMonth = new Date(
            today.getFullYear(),
            today.getMonth() + 1,
            0
          );
          var expirationDate = new Date(
            "20" + model.expiration_year,
            model.expiration_month,
            0
          );
          if (lastDayOfMonth.getTime() < expirationDate.getTime()) {
            return true;
          }
        }
      }
      return false;
    },
    showMethods(payMethod) {
      this.$refs.vfg.validate();
      if (this.$refs.vfg.errors.length > 0) {
        this.$swal({
          type: "error",
          title: this.$t("lang.label.error"),
          text: this.$t("lang.label.checkdeerrormessagesintheformandtryagain"),
          showConfirmButton: true,
        });
      } else {
        this.redirectViva(payMethod);
        // if (this.confirmPayment) {
        //   this.$swal({
        //     type: "warning",
        //     title: this.$t("lang.label.areyousure"),
        //     text: this.$t("lang.label.youaregoingtoaddanewpaymentmethod"),
        //     showCancelButton: true,
        //     confirmButtonColor: "#3085d6",
        //     cancelButtonColor: "#d33a2c",
        //     confirmButtonText: this.$t("lang.button.yes"),
        //   }).then((result) => {
        //     if (result.value) {
        //       this.saveSepaPaymentMethod();
        //     }
        //   });
        // } else {
        //   this.saveSepaPaymentMethod();
        // }
      }
    },

    redirectViva(payMethod) {
      //this.startLoading()

      this.btnMethods.sepa.disabled = true;
      this.btnMethods.creditCard.disabled = true;
      this.btnMethods.bankTransfer.disabled = true;
      this.btnMethods[payMethod].loading = true;

      let data = Object.assign({});
      if (payMethod === "sepa") {
        data.payment_method_type = "gocardless";
      }

      data.url = this.$route.path;
      data.role_id = 4;
      (data.address = this.selectedMethod.address),
        (data.country_id = this.selectedMethod.country_id),
        (data.code_postal = this.selectedMethod.code_postal),
        (data.city = this.selectedMethod.city),
        (data.vat_number = this.selectedMethod.vat_number
          ? this.selectedMethod.vat_number
          : null);
      if (this.userId) {
        data.user_id = this.userId;
        proporsalService.saveSepaPaymentMethod(data).then((response) => {
          window.dataLayer = window.dataLayer || [];
          dataLayer.push({
            event: "Paiement_Enregistré_Parcours_Commercial",
          });
          // VIVA PAYMENTS
          if (response.orderCode !== undefined) {
            window.location.href = response.orderCode;
            return;
          }
        });
      } else {
        billingsService.saveSepaPaymentMethod(data).then((response) => {
          // VIVA PAYMENTS
          if (response) {
            window.location.href = response.orderCode;
            return;
          }
        });
      }
    },

    saveSepaPaymentMethod(termsModel) {
      return new Promise((resolve, reject) => {
        // JavaEnabled,ColorDepth,ScreenHeight,ScreenWidth,TimeZone,AcceptHeader,UserAgent
        if (termsModel === undefined) {
          termsModel = {};
        }
        let browserInfo = {
          browserColorDepth: screen.colorDepth,
          browserJavaEnabled: navigator.javaEnabled(),
          browserLanguage: navigator.language,
          browserScreenHeight: screen.height,
          browserScreenWidth: screen.width,
          browserTimeZone: new Date().getTimezoneOffset(),
        };

        this.startLoading();
        let data = Object.assign(
          this.$refs.vfg.model,
          this.subscriptionData,
          termsModel,
          browserInfo
        );

        data.url = this.$route.path;

        if (this.userId) {
          data.user_id = this.userId;
          data.role_id = 4;
          proporsalService
            .saveSepaPaymentMethod(data)
            .then((response) => {
              window.dataLayer = window.dataLayer || [];
              dataLayer.push({
                event: "Paiement_Enregistré_Parcours_Commercial",
              });

              this.closeCreditCardModal();

              // VIVA PAYMENTS
              if (response.orderCode !== undefined) {
                window.location.href = response.orderCode;
                return;
              } else {
                this.showerror = true;
                return;
              }

              /*
              //INGENICO
              if (response.ingenico !== undefined) {
                let responseIngenico = response.ingenico;
                this.$router.push("/payment/" + responseIngenico);
                return;
              } else if (response == "success") {
                this.$swal({
                  type: "success",
                  title: this.$t("lang.label.great"),
                  showConfirmButton: false,
                  timer: 1500,
                });
                this.reloadComponent();
                resolve("ok");
                return;
              } else {
                this.showerror = true;
                return;
              }*/
            })
            .catch((err) => {
              this.$swal({
                type: "error",
                title: this.$t("lang.label.error"),
                html: this.$t("lang.label.paymentmethodaddederror"),
                showConfirmButton: false,
                timer: 9000,
              });
              reject("error");
              return;
            })
            .finally(() => {
              this.finishLoading();
            });
        } else {
          billingsService
            .saveSepaPaymentMethod(data)
            .then((response) => {
              // VIVA PAYMENTS
              if (response.orderCode !== undefined) {
                window.location.href = response.orderCode;
                return;
              } else {
                this.showerror = true;
                return;
              }

              /*
              //INGENICO
              if (response.ingenico !== undefined) {
                this.closeCreditCardModal();
                let responseIngenico = response.ingenico;
                this.$router.push("/payment/" + responseIngenico);

                return;
              } else if (response == "success") {
                this.refreshPaymentMethods();
                this.$swal({
                  type: "success",
                  title: this.$t("lang.label.great"),
                  showConfirmButton: false,
                  timer: 1500,
                });
                resolve("ok");
                return;
              } else {
                this.showerror = true;
                return;
              }*/
            })
            .catch((err) => {
              //console.log("catch error cc" + err);
              this.$swal({
                type: "error",
                title: this.$t("lang.label.error"),
                html: this.$t("lang.label.paymentmethodaddederror"),
                showConfirmButton: false,
                timer: 9000,
              });
              reject("error");
              return;
            });
        }
      });
    },

    refreshPaymentMethods() {
      this.$emit("refreshPaymentMethods", true);
    },
    closeCreditCardModal() {
      this.$emit("closeCreditCardModal", true);
    },
    reloadComponent() {
      this.$emit("reloadComponent", true);
    },
  },
};

$("#cardnumber").on("keyup", function (e) {
  var val = $(this).val();
  var newval = "";
  val = val.replace(/\s/g, "");
  for (var i = 0; i < val.length; i++) {
    if (i % 4 == 0 && i > 0) newval = newval.concat(" ");
    newval = newval.concat(val[i]);
  }
  $(this).val(newval);
});
</script>
